"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteEquitiesById = deleteEquitiesById;
exports.deleteGradeById = deleteGradeById;
exports.getEquitiesId = getEquitiesId;
exports.getGradeId = getGradeId;
exports.gradeEquitiesSelPage = gradeEquitiesSelPage;
exports.insertEquitiesNew = insertEquitiesNew;
exports.insertGradeNew = insertGradeNew;
exports.updateEquitiesOne = updateEquitiesOne;
exports.updateGradeOne = updateGradeOne;
exports.uploadBackgroundAddOrUpd = uploadBackgroundAddOrUpd;
exports.uploadPhoto = uploadPhoto;
exports.uploadPhotoAddOrUpd = uploadPhotoAddOrUpd;
exports.xyRuleVipGradeSelPage = xyRuleVipGradeSelPage;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
// 获取等级列表
function xyRuleVipGradeSelPage(query) {
  return (0, _requestAuth.default)({
    url: '/xyRuleVipGrade/page',
    method: 'get',
    params: query
  });
}

// 添加等级
function insertGradeNew(data) {
  return (0, _requestAuth.default)({
    url: '/xyRuleVipGrade/insert',
    method: 'post',
    data: data
  });
}

// 编辑等级
function updateGradeOne(data) {
  return (0, _requestAuth.default)({
    url: '/xyRuleVipGrade/basicUpdate',
    method: 'put',
    data: data
  });
}

// 删除等级信息
function deleteGradeById(id) {
  return (0, _requestAuth.default)({
    url: '/xyRuleVipGrade?id=' + id,
    method: 'delete'
  });
}

// 通过id等级信息
function getGradeId(id) {
  return (0, _requestAuth.default)({
    url: '/xyRuleVipGrade/' + id,
    method: 'get'
  });
}

// 附件上传
function uploadPhoto(params) {
  return (0, _requestAuth.default)({
    url: '/xyRuleVipGrade/uploadPhoto',
    method: 'post',
    data: params
  });
}

//  附件上传--等级背景
function uploadBackgroundAddOrUpd(params) {
  return (0, _requestAuth.default)({
    url: '/xyRuleVipGrade/uploadBackgroundAddOrUpd',
    method: 'post',
    data: params
  });
}

//  =============== 权益相关 ======================
// 获取权益列表
function gradeEquitiesSelPage(query) {
  return (0, _requestAuth.default)({
    url: '/xyGradeEquities/page',
    method: 'get',
    params: query
  });
}

//  新增权益
function insertEquitiesNew(data) {
  return (0, _requestAuth.default)({
    url: '/xyGradeEquities/insert',
    method: 'post',
    data: data
  });
}

//  编辑权益
function updateEquitiesOne(data) {
  return (0, _requestAuth.default)({
    url: '/xyGradeEquities/basicUpdate',
    method: 'put',
    data: data
  });
}

//  删除权益
function deleteEquitiesById(id) {
  return (0, _requestAuth.default)({
    url: '/xyGradeEquities?id=' + id,
    method: 'delete'
  });
}

//  通过id查询权益
function getEquitiesId(id) {
  return (0, _requestAuth.default)({
    url: '/xyGradeEquities/' + id,
    method: 'get'
  });
}

//  附件上传--等级权益
function uploadPhotoAddOrUpd(params) {
  return (0, _requestAuth.default)({
    url: '/xyGradeEquities/uploadPhotoAddOrUpd',
    method: 'post',
    data: params
  });
}